export default __webpack_public_path__ + "static/media/img5.70e0cd39.png";